import { accordionToggle } from '../utilities/accordion';

export default function () {
	const buttons = document.querySelectorAll('.accordion-toggle');

	if (buttons.length > 0) {
		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				accordionToggle(button, button.nextSibling.nextElementSibling);
			});
		});
	}
}
